import React from 'react';
import moment from 'moment';
import { Link } from '@material-ui/core';
import ListarDatos from '../../../../general/ListarDatos';
import { BtnVer } from '../../../../general/BotonesAccion';
import { obtenerAutorAdjunto } from '../../helpers/bienestarFichaUtils';

const AVATAR_GRIS = { backgroundColor: '#d1d1d1ff', color: '#FFFFFF' };

const renderAccion = (row) => {
    if (!row?.archivo) return null;
    return (
        <Link href={`${row.archivo}`} target="_blank" rel="noopener noreferrer">
            <BtnVer callback={() => { }} />
        </Link>
    );
};


function DetalleAdjuntosTab({ adjuntos, seleccion }) {
    const filasAdjuntos = [
        { id: 'fecha_registro', nombre: 'Fecha:', mostrar: ({ fecha_registro }) => moment(fecha_registro).format('YYYY-MM-DD, h:mm a') },
    ];
    if (seleccion === 'documentos_generados') {
        filasAdjuntos.unshift({
            id: 'autor_documento',
            nombre: 'Autor:',
            mostrar: (row) => obtenerAutorAdjunto(row) || 'Sin información',
        });
    }
    return (
        <ListarDatos
            datos={adjuntos}
            id='tbl_adjuntos_bienestar'
            acciones={renderAccion}
            avatar={({ nombre_archivo, texto }) => (nombre_archivo || texto || 'A').charAt(0).toUpperCase()}
            color_avatar={() => AVATAR_GRIS}
            fila_principal={({ nombre_archivo, texto }) => (nombre_archivo || texto || 'Archivo').toUpperCase()}
            filas={filasAdjuntos}
        />
    );
}

export default React.memo(DetalleAdjuntosTab);
